import type { Normalizer } from '../format'

export class EnumNormalizer implements Normalizer {
  matches(input: string) {
    const hasWhiteSpace = /\s/.test(input)
    const hasUppercase = /[A-Z]/.test(input)
    const hasLowercase = /[a-z]/.test(input)
    const hasUnderscore = /_/.test(input)

    return !hasWhiteSpace && !hasLowercase && hasUppercase && hasUnderscore
  }

  normalize(input: string) {
    return input.split('_').map((part) => part.trim().toLowerCase())
  }
}
